import React, { useState } from 'react';
import MediaQuery from 'react-responsive';
import { t } from 'i18next';
import clsx from 'clsx';
import Step from '../../components/step';
import Input from '../../components/input';
import ActionFooter from '../../components/action-footer';
import styles from './index.module.scss';

export default function LoginPassword(props) {
  const [initialFocus, setInitialFocus] = useState(false);
  const [passwordRef, setPasswordRef] = useState(undefined);
  const [password, setPassword] = useState('');
  const {
    step,
    currentStep,
    token,
    onBackClick,
    onLoginClick,
    onForgotPasswordClick,
    onInputChange,
    error,
  } = props;

  if (step !== currentStep && initialFocus) {
    setInitialFocus(false);
  } else if (step == currentStep && !initialFocus && passwordRef) {
    setInitialFocus(true);
    setPassword('');
    onInputChange && onInputChange('');
    setTimeout(() => {
      if (step == currentStep) {
        passwordRef && passwordRef.focus();
      }
    }, 300);
  }

  return (
    <Step className="stepstyles" number={step} current={currentStep}>
      <MediaQuery minHeight={410}>
        <div className={clsx(styles.logo, 'logo', 'password-logo')} />
      </MediaQuery>

      {/* Text */}
      <div className="password-container">
        <MediaQuery minHeight={360}>
          <div className={clsx(styles.header1, 'header1', 'password-header1')}>
            {t('login-password.text')}
          </div>
          <div className={clsx(styles.header2, 'header2', 'password-header2')}>{token}</div>
        </MediaQuery>

        {/* Login field */}
        <div className={clsx(styles.input, 'input', 'password-input')}>
          <Input
            ref={(element) => setPasswordRef(element)}
            placeholder={t('login-password.placeholder')}
            style={{ width: '80%' }}
            type="password"
            value={password}
            onChange={(e) => {
              onInputChange && onInputChange(e.target.value);
              setPassword(e.target.value);
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                if (!password || password.length == 0) {
                  passwordRef && passwordRef.focus();
                }
                onLoginClick(password);
              }
            }}
            helperText={error}
          />
        </div>

        {/* Create account button */}
        <div className={clsx(styles.forgot1, 'password-forgot1')}>
          <font onClick={() => onForgotPasswordClick()}>{t('login-password.helper_text')}</font>
        </div>

        {/* Create account button */}
        <div className={clsx(styles.forgot2, 'password-forgot2')}>
          <font onClick={() => onForgotPasswordClick()}>{t('login-password.send_otp')}</font>
        </div>
      </div>

      {/* Buttons */}
      <ActionFooter
        backText={t('login-password.back_button')}
        nextText={t('login-password.next_button')}
        onNextClick={() => {
          if (!password || password.length == 0) {
            passwordRef && passwordRef.focus();
          }
          onLoginClick(password);
        }}
        onBackClick={() => onBackClick()}
      />
    </Step>
  );
}
